import {Injectable} from '@angular/core';
import * as XLSX from 'xlsx';

export type Factions = 'Nova' | 'Fiendheim';
export type Backgrounds = 'Nova' | 'Fiendheim' | 'Arth';
export type AbilityTypes = 'Buff' | 'Debuff';

export interface CharacterSpreadsheetAbility {
  'Card Name': string;
  'Ability Type': string;
  Ability: string;
  Order: number;
  Power: number;
  Faction: Factions;
  Priority: number;
}

export interface CharacterSpreadsheet {
  Champions: Array<any>;
  Abilities: Array<CharacterSpreadsheetAbility>;
}

export interface Character {
  // Minimum set for display.
  name: string;
  faction: Factions;
  brawl: number;
  priority: number;
  ability: string;
  background: Backgrounds;

  // Optional.
  abilityType?: AbilityTypes;
  nHeaderLines?: number;
}

@Injectable()
export class CharacterService {
  public spreadsheet: CharacterSpreadsheet | null = null;

  public characters: Array<Character> = [];

  public safeName(str: string): string {
    return str.replace(/\W/g, '');
  }

  public loadSheet(file: File) {
    try {
      let workBook = null;
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = reader.result;
        workBook = XLSX.read(data, {type: 'binary'});
        this.spreadsheet = workBook.SheetNames.reduce((initial, name) => {
          const sheet = workBook.Sheets[name];
          initial[name] = XLSX.utils.sheet_to_json(sheet);
          return initial;
        }, {});
        if (this.spreadsheet) {
          for (const ability of this.spreadsheet.Abilities) {
            const character: Character = {
              name: ability['Card Name'],
              background: ability.Faction,
              ability: ability.Ability,
              brawl: ability.Power,
              faction: ability.Faction,
              priority: ability.Priority
            };
            this.characters.push(character);
          }
        }
        console.log(this.spreadsheet);
      };
      reader.readAsBinaryString(file);
    } catch (exception) {
      console.log('exception:', exception);
    }
  }
}
